import React, { Fragment } from "react";
import { Progress } from 'reactstrap';

class BoxValue extends React.Component {

    render() {
        const colorClass = this.props.color ? this.props.color : '';
        const textColorClass = this.props.textColor ? this.props.textColor : '';
        return (
            <Fragment>
                <div className={'card mb-3 widget-content ' + colorClass}>
                    <div className="widget-content-outer">
                        <div className="widget-content-wrapper">
                            <div className={'widget-heading ' + textColorClass}>
                                {this.props.heading}
                            </div>
                        </div>
                        <div className="widget-content-wrapper">
                            <div className={'widget-numbers text-secondary '  + textColorClass}>
                                {this.props.value}
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default BoxValue;